import React from "react";
import { Box, Text, Link, Flex, Divider, Select } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

const Footer = ({ sidebarWidth = "0px" }) => {
  const { t, i18n } = useTranslation();

  // Language switch handler
  const handleLanguageChange = (event) => {
    i18n.changeLanguage(event.target.value);
  };

  return (
    <Box
      bg="white" // Light background
      color="gray.600" // Darker text
      py={4}
      mt={8}
      ml={sidebarWidth}
      transition="margin-left 0.3s ease-in-out"
      borderTop="1px" // Subtle border
      borderColor="gray.200" // Light border color
    >
      <Divider />
      <Flex direction="column" align="center" justify="center" pt={4}>
        <Text fontSize="sm">© {new Date().getFullYear()} PeerX. {t("footer.rights_reserved")}</Text>
        <Flex gap={4} mt={2}>
          <Link href="/terms" color="gray.500" _hover={{ color: "blue.500" }}>
            {t("footer.terms")}
          </Link>
          <Link href="/privacy" color="gray.500" _hover={{ color: "blue.500" }}>
            {t("footer.privacy")}
          </Link>
        </Flex>

        {/* Language Switcher */}
        <Box mt={4}>
          <Select
            value={i18n.language}
            onChange={handleLanguageChange}
            width="120px"
            bg="white"
            color="black"
            size="sm"
          >
            <option value="en">English</option>
            <option value="fr">Français</option>
            <option value="es">Español</option>
          </Select>
        </Box>
      </Flex>
    </Box>
  );
};

export default Footer;
